export default __webpack_public_path__ + "static/media/Inactive_black.d0d12c49.svg";